import {
  useDialogStoreOptions,
  useDialogStoreProps
} from "./WC3GK4CL.js";
import {
  useStore,
  useStoreProps
} from "./P63NRZ4A.js";
import {
  __spreadValues
} from "./PNRLI7OV.js";

// src/popover/popover-store.ts
import * as Core from "@ariakit/core/popover/popover-store";
function usePopoverStoreOptions(props) {
  return useDialogStoreOptions(props);
}
function usePopoverStoreProps(store, props) {
  store = useDialogStoreProps(store, props);
  useStoreProps(store, props, "placement");
  return store;
}
function usePopoverStore(props = {}) {
  const options = usePopoverStoreOptions(props);
  const store = useStore(
    () => Core.createPopoverStore(__spreadValues(__spreadValues({}, props), options))
  );
  return usePopoverStoreProps(store, props);
}

export {
  usePopoverStoreOptions,
  usePopoverStoreProps,
  usePopoverStore
};
